import {Image} from '@mantine/core';
import {Carousel, CarouselProps} from '../Carousel/Carousel';

export type ImageCarouselProps = Omit<CarouselProps, 'children'> & {
  data?: { src: string; alt?: string, caption?: string }[]
}

export const ImageCarousel = (props: ImageCarouselProps) => {
  const {data, ...rest} = props;

  const slides = data?.map((datum) => (
    <Carousel.Slide key={datum.src}>
      <Image
        src={datum.src}
        alt={datum.alt}
        caption={datum.caption}
        fit={"contain"}
        height="500px"
        withPlaceholder={true}
        />
    </Carousel.Slide>
  ));

  return (
    <Carousel {...rest}>
      {slides}
    </Carousel>
  );
}
